import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";
import {
  AiOutlineCopy,
  AiOutlineLike,
  AiOutlineDislike,
  AiFillLike,
  AiFillDislike,
  AiOutlineClose,
} from "react-icons/ai";
import { BsFiletypeCsv, BsThreeDots } from "react-icons/bs";
import { HiMiniClipboardDocumentCheck } from "react-icons/hi2";
import Logo from "../../Assets/OkationLogo.png";
import Okation from "../../Assets/boxMind_wide.png";
import Turbo from "../../Assets/boxMind_wide.png";
import ChatUser from "../../Assets/ChatPerson.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactDOM from "react-dom";
import { HiOutlineRefresh } from "react-icons/hi";
import ChatHistory from "./History/ChatHistory";
import DeleteAllRooms from "../Chat/History/DeleteAllRooms";
// import Model from "../Chat/Model";
// import Agent from "../Chat/Agent";
// import Tag from "../Chat/Tag";
// import CustomInstructions from "../Chat/CustomInstructions";
import { CiFileOn } from "react-icons/ci";
import Cookies from "js-cookie";
import EmailInfo from "./EmailInfo";
import api from "../api";
import { AsyncImage } from "loadable-image";
import { Blur } from "transitions-kit";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
// import { GoImage } from "react-icons/go";
// import { MdOutlineCancel } from "react-icons/md";
// import { CgAttachment } from "react-icons/cg";
import { PiMicrosoftExcelLogoLight } from "react-icons/pi";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { dracula } from "react-syntax-highlighter/dist/esm/styles/prism";
import remarkMath from "remark-math";
import rehypeMathJax from "rehype-mathjax";
import remarkGfm from "remark-gfm";
import DislikeFeedback from "./DislikeFeedback";
import styles from "./ChatStyles.module.css";
import Prompt from "./Prompt/Prompt";
import Preview from "./Preview/Preview";
import ChatInput from "./ChatInput/ChatInput";
import NewChatButton from "./NewChatButton/NewChatButton";
import QuestionsList from "./QuetsionsList/QuestionsList";
import XSDExplorer from "./XSDExplorer/XSDExplorer";

let currentInputVar = 0;
let currentCodeInputVar = 0;
let currentImgInputVar = 0;
let firsttoken = 0;
let lastgeneratingcode = 0;
let newChatRefresh = 0;
let imageBase64Data = "";
let currentImageInputVar = 0;
let printcode = false;
let printgeneratecode = false;
let printimage = false;

let search_engine =
  Cookies.get("search_engine") !== undefined ? Cookies.get("search_engine") : 0;
let pdf_name = Cookies.get("pdf_name") ? Cookies.get("pdf_name") : "";
let selected_tag_search = Cookies.get("selected_tag")
  ? Cookies.get("selected_tag")
  : "";
let selected_agent_search = Cookies.get("selected_agent")
  ? Cookies.get("selected_agent")
  : "";
let selected_tag_name_search = Cookies.get("selected_tag")
  ? Cookies.get("selected_tag_name")
  : "";
let selected_agent_name_search = Cookies.get("selected_agent")
  ? Cookies.get("selected_agent_name")
  : "";

interface Message {
  type: "input" | "response" | "clipboard";
  message: JSX.Element | string;
  chat_details_id?: string;
}

type VersionItem = {
  id: string;
  version: number;
  sqlCode: string;
  graphCode: string;
  previewContent: string;
  label: string;
  isLive: boolean;
};

interface History {
  chat_details_id: string;
  room_id: number;
  question: string;
  answer: string;
  error: string;
  response_time: string;
  pdf_name: string;
  like: string;
  dislike: string;
  is_regenerated: string;
  user_comments: string;
  question_date_time: string;
  faithfulness: string;
  answer_relevancy: string;
  context_relevancy: string;
  debug: number;
  sources: string;
  image: string;
  chat_settings: {
    sql_query: string;
    sql_query_result: string;
    version_name: string;
    graph_code: string;
  };
}

interface TagData {
  id: string;
  tag_name: string;
}

const Thinking = [
  "Searching...",
  "Fetching the data...",
  "Generating response...",
];

const examples: string[] = [
  "Show the top 10 most used SWIFT message types in the last 5 years.",
  "Which 10 BICs have sent the most messages in the last five years?",
  "Give me the average transaction amount per currency in the last 6 months.",
  "Show 10 recent transactions involving banks in LEBANON.",
  "Show top 10 BICs by total amount sent between 2022 and 2025.",
  "Give me 10 messages that have no acknowledgment status.",
];

interface MindAgentData {
  id: string;
  agent: string;
  logo: string;
  description: string;
}

function NewChat({ userData }: any): JSX.Element {
  const [messageList, setMessageList] = useState<Message[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [inputMessage, setInputMessage] = useState<string>("");

  const clientId = localStorage.getItem("user_id");
  const user_name = userData?.data?.user_name;

  const [debugMode, setDebugMode] = useState<string>("0");

  const [selectedRoomId, setSelectedRoomId] = useState<number>(
    Math.round(Math.random() * 1e9)
  );

  //visibility
  const [sidebarVisible, setSidebarVisible] = useState<boolean>(true);
  const [moreOptions, setMoreOptions] = useState<boolean>(false);

  //References
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  const [loading, setLoading] = useState<boolean>(false);
  const [responseStarted, setResponseStarted] = useState<boolean>(false);
  const [messageIndex, setMessageIndex] = useState(0);
  const [previousQuestion, setPreviousQuestion] = useState<string>("");

  //Model
  const [modelActive, setModelActive] = useState<boolean>(false);
  const [selectedModel, setSelectedModel] = useState<string>("boxMind");

  //Agent
  const [mindAgentData, setMindAgentData] = useState<MindAgentData[] | null>(
    null
  );
  const [agentActive, setAgentActive] = useState<boolean>(false);
  const [selectedAgent, setSelectedAgent] = useState<string | null>(null);
  const [selectedAgentId, setSelectedAgentId] = useState<string | null>(null);

  const [refreshRooms, setRefreshRooms] = useState(0);

  //tag
  const [tagActive, setTagActive] = useState<boolean>(false);
  const [selectedTag, setSelectedTag] = useState(
    selected_tag_search ? selected_tag_search : null
  );
  const [selectedTagName, setSelectedTagName] = useState(
    selected_tag_name_search ? selected_tag_name_search : ""
  );
  const [canResetTag, setCanResetTag] = useState("0");

  //Custom Instructions
  const [customInstructions, setCustomInstructions] = useState(null);
  const [customInstructionsName, setCustomInstructionsName] = useState("");
  const [customInstructionsActive, setCustomInstructionsActive] =
    useState<boolean>(false);

  // User Instructions
  const [userInstructions, setUserInstructions] = useState(null);
  const [userInstructionsName, setUserInstructionsName] = useState("");
  const [userInstructionsActive, setUserInstructionsActive] =
    useState<boolean>(false);
  const [questionsListActive, setQuestionsListActive] =
    useState<boolean>(false);

  //Email
  const [isEmailInfoOpen, setEmailInfoOpen] = useState(false);
  const [emailData, setEmailData] = useState("");
  const [tokenChanged, setTokenChanged] = useState<string[]>([]);

  //History Chat
  const [historyData, setHistoryData] = useState<History[]>([]);

  //Image
  const [expandedImage, setExpandedImage] = useState(null);

  //Exel
  const [file, setFile] = useState<File | null>(null);

  const [isScrolledUp, setIsScrolledUp] = useState<boolean>(false);
  const [shuffledExamples, setShuffledExamples] = useState<string[]>([]);
  const [openDeleteAll, setOpenDeleteAll] = useState(false);

  const user_id = localStorage.getItem("user_id") || "default_user";
  const [mindTagData, setMindTagData] = useState<TagData[] | null>(null);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [chatDetailsId, setChatDetailsId] = useState<string | null>(null);

  const [showDislikeFeedback, setShowDislikeFeedback] =
    useState<boolean>(false);
  const [currentFeedbackId, setCurrentFeedbackId] = useState<string>("");

  const [showPreview, setShowPreview] = useState(false);

  const [showCodeModal, setShowCodeModal] = useState(false);

  const [showDownloadMenu, setShowDownloadMenu] = useState(false);

  // Preview State
  const [previewContent, setPreviewContent] = useState<string>("");
  const [isCollectingPreview, setIsCollectingPreview] =
    useState<boolean>(false);
  const isCollectingPreviewRef = useRef<boolean>(false);

  //Sql State
  const [sqlCode, setSqlCode] = useState<string>("");
  const [isCollectingSql, setIsCollectingSql] = useState<boolean>(false);
  const isCollectingSqlRef = useRef<boolean>(false);
  const [isSqlCaptureStarted, setIsSqlCaptureStarted] =
    useState<boolean>(false);
  const sqlBufferRef = useRef<string>("");
  const captureEnabledRef = useRef<boolean>(false);
  const [isSqlStreaming, setIsSqlStreaming] = useState<boolean>(false);

  //Graph State
  const [graphCode, setGraphCode] = useState<string>("");
  const [isCollectingGraph, setIsCollectingGraph] = useState<boolean>(false);
  const isCollectingGraphRef = useRef<boolean>(false);
  const [isGraphCaptureStarted, setIsGraphCaptureStarted] =
    useState<boolean>(false);
  const graphBufferRef = useRef<string>("");
  const captureGraphEnabledRef = useRef<boolean>(false);
  const [isGraphStreaming, setIsGraphStreaming] = useState<boolean>(false);
  const lastGraphVersionRef = useRef<number | null>(null);
  const pendingGraphForVersion = useRef<number | null>(null);
  const isGraphStreamingForPendingVersion = useRef<boolean>(false);

  // Version State
  const [versions, setVersions] = useState<VersionItem[]>([]);
  const [activeVersionId, setActive] = useState<string | null>(null);
  const [activeVersionNumber, setActiveVersionNumber] = useState<number | null>(
    1
  );

  const [selectedVersionName, setSelectedVersionName] = useState<string>("");

  const activeVersionNumberRef = useRef<number | null>(activeVersionNumber);

  useEffect(() => {
    activeVersionNumberRef.current = activeVersionNumber;
  }, [activeVersionNumber]);

  //xsd
  const [xsdExplorerActive, setXsdExplorerActive] = useState(false);
  const [selectedXsdPath, setSelectedXsdPath] = useState<string | null>(null);
  const [xsdPathConditions, setXsdPathConditions] = useState([]);
  const [selectedXsdId, setSelectedXsdId] = useState<string>("");
  const [xsdXml, setXsdXml] = useState<string>("");
  const [treeData, setTreeData] = useState<any>(null);

  const showXSDExplorer = () => setXsdExplorerActive(!xsdExplorerActive);

  // keep the latest streaming values so we can snapshot them accurately
  const sqlRef = useRef<string>("");
  const previewRef = useRef<string>("");
  const graphRef = useRef<string>("");

  // simple counter that we'll bump each time we create a version
  const versionCounter = useRef<number>(1);

  const lastVersionNumberRef = useRef<number | null>(null);

  // Update refs when state changes
  useEffect(() => {
    isCollectingSqlRef.current = isCollectingSql;
  }, [isCollectingSql]);

  useEffect(() => {
    isCollectingPreviewRef.current = isCollectingPreview;
  }, [isCollectingPreview]);

  useEffect(() => {
    isCollectingGraphRef.current = isCollectingGraph;
  }, [isCollectingGraph]);

  //Agent Fetch
  // useEffect(() => {
  //   const fetchData = async () => {
  //     setLoading1(true);
  //     setLoading2(true);
  //     try {
  //       const responseAgents = await api.get(
  //         `${process.env.REACT_APP_AGENTS_BY_USER}${user_id}`
  //       );
  //       const dataAgents = responseAgents.data;
  //       setMindAgentData(dataAgents);

  //       if (dataAgents && dataAgents.length > 0) {
  //         setSelectedAgent(
  //           selected_agent_name_search
  //             ? selected_agent_name_search
  //             : dataAgents[0].agent
  //         );
  //         setSelectedAgentId(
  //           selected_agent_search ? selected_agent_search : dataAgents[0].id
  //         );
  //       }

  //       setLoading1(false);
  //       setLoading2(false);
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchData();
  // }, [user_id]);

  //tag fetch
  // useEffect(() => {
  //   const apiUrl = `${process.env.REACT_APP_TAGS_BY_AGENT}${selectedAgentId}`;

  //   if (canResetTag === "1") {
  //     setSelectedTag("");
  //     setSelectedTagName("");
  //   }
  //   api
  //     .get(apiUrl)
  //     .then((response) => {
  //       const data = response.data;
  //       setMindTagData(data);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // }, [selectedAgentId, canResetTag]);

  const handleImageClick = (image: any) => {
    setExpandedImage(image);
  };

  const handleCloseModal = () => {
    setExpandedImage(null);
  };

  Cookies.remove("pdf_name");
  Cookies.remove("search_engine");
  Cookies.remove("selected_agent");
  Cookies.remove("selected_tag");
  Cookies.remove("selected_agent_name");
  Cookies.remove("selected_tag_name");

  //Show
  const showAgent = () => {
    setAgentActive(!agentActive);
  };

  const showTag = () => {
    setTagActive(!tagActive);
  };

  const showModel = () => {
    setModelActive(!modelActive);
  };

  const showCustomInstructions = () => {
    setCustomInstructionsActive(!customInstructionsActive);
  };

  const showUserInstructions = () => {
    setUserInstructionsActive(!userInstructionsActive);
  };

  const showQuestionsList = () => {
    setQuestionsListActive(!questionsListActive);
  };

  const toggleSidebar = () => {
    setSidebarVisible((prevVisible) => !prevVisible);
    setShowPreview(false);
  };

  useEffect(() => {
    if (!sidebarVisible) {
      setMoreOptions(false);
    }
  }, [sidebarVisible]);

  const closePopUp = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeEmailInfoData();
    }
  };

  const closeEmailInfoData = () => {
    setEmailInfoOpen(false);
  };

  const openEmailInfoData = () => {
    setEmailInfoOpen(true);
  };

  useEffect(() => {
    // Determine the highest existing version number from historyData
    const existingVersions = historyData
      .flatMap((item) =>
        item.chat_settings ? [item.chat_settings.version_name] : []
      )
      .map((versionName) => parseInt(versionName.replace("V", ""))) // Extract the numeric part
      .filter((num) => !isNaN(num)); // Filter out any NaN values

    const highestVersion =
      existingVersions.length > 0 ? Math.max(...existingVersions) : 0;

    // Set the version counter to the highest version found
    versionCounter.current = highestVersion + 1; // Start from the next version
  }, [historyData]);

  //Recieve Answer
  useEffect(() => {
    const socket = io(`${process.env.REACT_APP_QUESTIONS}`, {
      path: "/socket.io",
    });

    socket.on("connect", () => {
      socket.emit("join", { room_id: selectedRoomId });
    });

    // track a sequence of SQL tokens manually
    let inSqlSection = false;
    let sqlBuffer = "";
    let skipNextSql = false;

    // track a sequence of Graph tokens manually
    let inGraphSection = false;
    let graphBuffer = "";
    let skipNextGraph = false;

    socket.on("token", (token: { data: string }) => {
      if (token.data === "Add_version_button") {
        const newVersionNumber = versionCounter.current;
        const newItem: VersionItem = {
          id: Math.round(Math.random() * 1e9).toString(),
          version: newVersionNumber,
          label: `V${newVersionNumber}`,
          sqlCode: sqlRef.current,
          graphCode: "",
          previewContent: previewRef.current,
          isLive: true,
        };
        pendingGraphForVersion.current = newVersionNumber;
        isGraphStreamingForPendingVersion.current = false;
        lastVersionNumberRef.current = newItem.version;
        setVersions((prev) => [...prev, newItem]);
        setActive(newItem.id);
        setActiveVersionNumber(newItem.version);
        activeVersionNumberRef.current = newItem.version;
        versionCounter.current += 1;

        const wrapper = document.getElementById(`text-wrap-${currentInputVar}`);
        if (wrapper) {
          const pill = document.createElement("button");
          pill.textContent = `V${newItem.version}`;
          pill.classList.add(
            "px-3",
            "py-1",
            "rounded",
            "bg-blue-600",
            "text-white",
            "hover:bg-blue-700",
            "my-2"
          );
          pill.onclick = () => {
            setActive(newItem.id);
            setActiveVersionNumber(newItem.version);
            setShowPreview(true);
            setSidebarVisible(false);
          };
          wrapper.appendChild(pill);
        }

        return; // stop further processing of this token
      }

      // Direct manual tracking of SQL section
      if (token.data === "start_sql") {
        inSqlSection = true;
        sqlBuffer = "";
        skipNextSql = true;
        // Open the SQL modal immediately when SQL starts
        // setShowCodeModal(true);
        setIsSqlStreaming(true);
        return;
      }

      if (token.data === "end_sql") {
        inSqlSection = false;
        // Set the SQL code directly
        setSqlCode(sqlBuffer);
        sqlBufferRef.current = sqlBuffer;
        sqlRef.current = sqlBuffer;
        captureEnabledRef.current = true;
        setIsSqlStreaming(false);

        // Debug: Set the attribute directly
        setTimeout(() => {
          document
            .getElementById("sql-debug")
            ?.setAttribute("data-sql", sqlBuffer);
        }, 100);
        return;
      }

      if (inSqlSection) {
        if (skipNextSql && token.data === "sql") {
          skipNextSql = false;
          return;
        }
        // Update SQL in real-time for streaming display
        sqlBuffer += token.data;
        setSqlCode(sqlBuffer); // Update the state immediately to show streaming
        sqlRef.current = sqlBuffer;
        return;
      }

      if (token.data === "start_graph") {
        if (activeVersionNumber != null) {
          pendingGraphForVersion.current = activeVersionNumberRef.current;
        }
        inGraphSection = true;
        graphBuffer = "";
        skipNextGraph = true;
        setIsGraphStreaming(true);
        isGraphStreamingForPendingVersion.current = true; // Mark that a graph is being streamed for the pending version
        return;
      }
      if (token.data === "end_graph") {
        inGraphSection = false;
        setGraphCode(graphBuffer);
        graphBufferRef.current = graphBuffer;
        graphRef.current = graphBuffer;
        captureGraphEnabledRef.current = true;
        setIsGraphStreaming(false);

        // Remember which live version actually owns this graph
        lastGraphVersionRef.current = pendingGraphForVersion.current;

        setTimeout(() => {
          document
            .getElementById("graph-debug")
            ?.setAttribute("data-graph", graphBuffer);
        }, 100);

        // Only update the latest version if a graph was actually streamed for it
        if (
          pendingGraphForVersion.current &&
          isGraphStreamingForPendingVersion.current
        ) {
          setVersions((prevVersions) => {
            const idx = prevVersions.findIndex(
              (v) => v.version === pendingGraphForVersion.current
            );
            if (idx !== -1) {
              const updated = [...prevVersions];
              updated[idx] = {
                ...updated[idx],
                graphCode: graphBuffer,
              };
              // console.log(
              //   `[end_graph] Stored graph for version V${pendingGraphForVersion.current}:`,
              //   graphBuffer
              // );
              return updated;
            }
            return prevVersions;
          });
        }
        // Reset the flag
        isGraphStreamingForPendingVersion.current = false;
        return;
      }

      if (inGraphSection) {
        if (skipNextGraph && token.data === "graph") {
          skipNextGraph = false;
          return;
        }
        // Update Graph in real-time for streaming display
        graphBuffer += token.data;
        setGraphCode(graphBuffer); // Update the state immediately to show streaming
        graphRef.current = graphBuffer;
        return;
      }

      // Original token handling below
      setResponseStarted(false);
      if (token.data === "end_stream") {
        return;
      }

      const responseMessage: Message = {
        type: "response",
        message: token.data,
      };

      // Handle preview start
      if (token.data === "start_preview") {
        setShowPreview(true);
        setSidebarVisible(false);
        setIsCollectingPreview(true);
        setPreviewContent("");
        previewRef.current = "";
        return;
      }

      // Handle preview end
      if (token.data === "end_preview") {
        setIsCollectingPreview(false);
        setIsCollectingSql(false);
        setIsCollectingGraph(false);
        setIsGraphCaptureStarted(false);
        setIsSqlCaptureStarted(false);

        // If no graph was streamed for this version, clear only the global state
        if (lastGraphVersionRef.current !== activeVersionNumber) {
          setGraphCode("");
          graphRef.current = "";
          // console.log(
          //   `[end_preview] No graph streamed for version V${activeVersionNumber}, cleared global graphCode`
          // );
        } else {
          // console.log(
          //   `[end_preview] Graph was streamed for version V${activeVersionNumber}, not clearing global graphCode`
          // );
        }

        return;
      }

      // Handle SQL start
      if (token.data === "start_sql") {
        setIsCollectingSql(true);
        setIsSqlCaptureStarted(true);
        setSqlCode("");
        return;
      }

      // Handle SQL end
      if (token.data === "end_sql") {
        setIsCollectingSql(false);
        setIsSqlCaptureStarted(false);
        return;
      }

      // Handle Graph start
      if (token.data === "start_graph") {
        setIsCollectingGraph(true);
        setIsGraphCaptureStarted(true);
        setGraphCode("");
        return;
      }

      // Handle Graph end
      if (token.data === "end_graph") {
        setIsCollectingGraph(false);
        setIsGraphCaptureStarted(false);
        return;
      }

      // Handle content after sql command (comes after start_sql)
      if (
        token.data === "sql" &&
        isCollectingPreviewRef.current &&
        isCollectingSqlRef.current
      ) {
        return;
      }

      // Collect SQL content
      if (isSqlCaptureStarted && token.data !== "sql") {
        // Force a direct update to ensure we capture it
        const newSqlCode = sqlCode + token.data;
        setSqlCode(newSqlCode);
        document
          .getElementById("sql-debug")
          ?.setAttribute("data-sql", newSqlCode);

        return;
      }

      // Handle content after graph command (comes after start_graph)
      if (
        token.data === "graph" &&
        isCollectingPreviewRef.current &&
        isCollectingGraphRef.current
      ) {
        return;
      }

      // Collect Graph content
      if (isGraphCaptureStarted && token.data !== "graph") {
        // Force a direct update to ensure we capture it
        const newGraphCode = graphCode + token.data;
        setGraphCode(newGraphCode);
        document
          .getElementById("graph-debug")
          ?.setAttribute("data-graph", newGraphCode);

        return;
      }

      // Collect preview content
      if (
        isCollectingPreviewRef.current &&
        !isSqlCaptureStarted &&
        !isGraphCaptureStarted
      ) {
        setPreviewContent((prev) => prev + token.data);
        previewRef.current += token.data;
        return;
      }

      if (token.data === "start_generate_code") {
        printgeneratecode = true;
        currentCodeInputVar++;

        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const generatingcode = document.createElement("div");
        generatingcode.setAttribute(
          "id",
          `code-generating-button-div-${currentCodeInputVar}`
        );
        generatingcode.setAttribute("number", currentCodeInputVar.toString());
        lastgeneratingcode = currentCodeInputVar;
        generatingcode.classList.add("generating-code");
        generatingcode.onclick = function () {
          showHide(currentCodeInputVar);
        };

        const textSpan =
          '<span style="display: inline-block; vertical-align: middle; margin-right: 5px;">GENERATING CODE</span>';
        const arrowSVG =
          '<span style="display: inline-block; vertical-align: middle;"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 8.295 12 12.875l4.59-4.58L18 9.705l-6 6-6-6z"></path></svg></span>';

        generatingcode.innerHTML = textSpan + arrowSVG;

        housebox?.appendChild(generatingcode);

        const parentbox = document.createElement("div");
        parentbox.classList.add("parentcodeboxstyle");
        parentbox.setAttribute("id", `parent-code-div-${currentCodeInputVar}`);
        parentbox.style.display = "none";
        housebox?.appendChild(parentbox);

        firsttoken = 1;
      } else if (token.data === "end_generate_code") {
        var generatedcode = document.getElementById(
          `code-generating-button-div-${currentCodeInputVar}`
        );
        if (generatedcode) {
          generatedcode.innerHTML =
            '<span style="display: inline-block; vertical-align: middle; margin-right: 5px;">CODE GENERATED</span>' +
            '<span style="display: inline-block; vertical-align: middle;"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M7.41 8.295 12 12.875l4.59-4.58L18 9.705l-6 6-6-6z"></path></svg></span>';
          generatedcode.classList.remove("generating-code");
          generatedcode.classList.add("generated-code");
        }
        printgeneratecode = false;
      } else if (token.data === "start_code") {
        printcode = true;
        currentCodeInputVar++;
        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const parentbox = document.createElement("div");
        parentbox.classList.add("parentcodeboxstyle");
        parentbox.setAttribute("id", `parent-code-div-${currentCodeInputVar}`);

        // Create title div for code block
        const titleDiv = document.createElement("div");
        titleDiv.classList.add("titlestyle");

        // Create code content div
        const codeContent = document.createElement("div");
        codeContent.classList.add("codeboxstyle");
        codeContent.setAttribute("id", `code-content-${currentCodeInputVar}`);

        parentbox.appendChild(titleDiv);
        parentbox.appendChild(codeContent);
        housebox?.appendChild(parentbox);
      } else if (token.data === "start_image") {
        // Handle start of image
        printimage = true;
        currentImageInputVar++;
        var housebox = document.getElementById(`text-wrap-${currentInputVar}`);

        const imageContainer = document.createElement("div");
        imageContainer.classList.add("image-container");
        imageContainer.setAttribute(
          "id",
          `image-container-${currentImageInputVar}`
        );
        housebox?.appendChild(imageContainer);

        imageBase64Data = "";
      } else if (token.data === "end_image") {
        printimage = false;
        var imageContainer = document.getElementById(
          `image-container-${currentImageInputVar}`
        );

        if (imageContainer && imageBase64Data) {
          const img = document.createElement("img");
          img.src = `data:image/png;base64,${imageBase64Data}`;
          img.classList.add("generated-image");
          imageContainer.appendChild(img);
        }
      } else if (printimage) {
        imageBase64Data += token.data;
      } else if (token.data === "end_code") {
        printcode = false;

        var codeBox = document.getElementById(
          `parent-code-div-${currentCodeInputVar}`
        );
        if (codeBox) {
          const titleDiv = codeBox.querySelector(".titlestyle");
          if (titleDiv) {
            const copyButton = document.createElement("button");
            copyButton.classList.add("copy-button");
            copyButton.textContent = "Copy";
            copyButton.onclick = () =>
              copyButtonHistory(currentCodeInputVar, currentInputVar);
            titleDiv.appendChild(copyButton);
          }

          const codeContent = codeBox.querySelector(".codeboxstyle");
          if (codeContent) {
            const codeText = codeContent.textContent || "";
            const lines = codeText.split("\n");
            const title = lines.shift() || "javascript";
            const codeWithoutTitle = lines.join("\n");

            ReactDOM.render(
              <SyntaxHighlighter language={title.toLowerCase()} style={dracula}>
                {codeWithoutTitle}
              </SyntaxHighlighter>,
              codeContent
            );
          }
        }
      } else if (printcode) {
        var codeBox = document.getElementById(
          `code-content-${currentCodeInputVar}`
        );
        if (codeBox) {
          const existingContent = codeBox.textContent || "";
          codeBox.textContent = existingContent + token.data;

          if (!codeBox.getAttribute("has-title")) {
            const titleDiv =
              codeBox.parentElement?.querySelector(".titlestyle");
            if (titleDiv) {
              titleDiv.textContent = token.data.split("\n")[0];
            }
            codeBox.setAttribute("has-title", "true");
          }
        }
      } else {
        var div = document.getElementById(`text-wrap-${currentInputVar}`);
        if (div) {
          if (token.data.startsWith("{'source': ")) {
            try {
              const sourceObj = JSON.parse(
                token.data.replace(/'/g, '"').replace(/None/g, "null")
              );
              if (sourceObj.source) {
                if (sourceObj.type === "email") {
                  const sourceDiv = document.createElement("div");
                  sourceDiv.classList.add("source-reference");

                  // Create a span for the source text to apply styles
                  const sourceText = document.createElement("span");
                  sourceText.textContent = `${sourceObj.source}`;
                  sourceText.style.textDecoration = "underline";
                  sourceText.style.marginRight = "8px";
                  sourceText.style.marginTop = "8px";
                  sourceText.style.cursor = "pointer";
                  sourceText.onclick = () => {
                    setEmailData(sourceObj.full_data);
                    openEmailInfoData();
                  };

                  // Append the source text and button to the sourceDiv
                  sourceDiv.appendChild(sourceText);
                  div.appendChild(sourceDiv);
                } else {
                  const sourceDiv = document.createElement("div");
                  sourceDiv.classList.add("source-reference");

                  // Create a span for the source text to apply styles
                  const sourceText = document.createElement("span");
                  sourceText.textContent = `${sourceObj.source}`;
                  sourceText.style.textDecoration = "underline";
                  sourceText.style.marginRight = "8px";
                  sourceText.style.marginTop = "8px";
                  sourceText.style.cursor = "pointer";
                  sourceText.onclick = () => {
                    window.open(
                      `https://bank.boxmindlabs.ai/${sourceObj.source}`,
                      "_blank"
                    );
                  };

                  // Create chat button
                  const chatButton = document.createElement("button");
                  chatButton.textContent = "Chat";
                  chatButton.classList.add("chat-button");
                  chatButton.style.color = "blue";
                  chatButton.style.textDecoration = "underline";
                  chatButton.style.background = "none";
                  chatButton.style.border = "none";
                  chatButton.style.cursor = "pointer";
                  chatButton.onclick = () => {
                    openNewChatWithSource(sourceObj.source);
                  };

                  // Append the source text and button to the sourceDiv
                  sourceDiv.appendChild(sourceText);
                  sourceDiv.appendChild(chatButton);
                  div.appendChild(sourceDiv);
                }
              }
            } catch (error) {
              console.error("Error parsing source:", error);
            }
          } else {
            let currentParagraph = div.lastElementChild;
            if (
              !currentParagraph ||
              currentParagraph.classList.contains("parentcodeboxstyle") ||
              currentParagraph.classList.contains("source-reference") ||
              currentParagraph.classList.contains("image-container")
            ) {
              currentParagraph = document.createElement("div");
              currentParagraph.classList.add(
                "markdown-paragraph",
                styles.chatMarkdown
              );
              div.appendChild(currentParagraph);
            }

            const existingContent =
              currentParagraph.getAttribute("data-content") || "";
            const newContent = existingContent + token.data;
            currentParagraph.setAttribute("data-content", newContent);

            ReactDOM.render(
              <ReactMarkdown
                remarkPlugins={[remarkMath, remarkGfm]}
                rehypePlugins={[rehypeMathJax]}
              >
                {newContent}
              </ReactMarkdown>,
              currentParagraph
            );
          }
        }
      }

      setMessageList((prevMessageList) => [
        ...prevMessageList,
        responseMessage,
      ]);
    });

    return () => {
      socket.off("token");
      socket.close();
    };
  }, [clientId, selectedRoomId]);

  useEffect(() => {
    tokenChanged.map((val: any) => {
      var hellodiv = document.getElementById(val);
      if (hellodiv) {
        hellodiv.addEventListener("click", () => setEmailData(val));
        hellodiv.addEventListener("click", () => openEmailInfoData());
      }
    });
  }, [tokenChanged]);

  const showHide = (val: any) => {
    var codess = document.getElementById(`parent-code-div-${val}`);
    if (codess) {
      codess.style.display = codess.style.display === "none" ? "block" : "none";
    }
  };

  // useEffect(() => {
  //   if (loading === false) {
  //     var generatedcode = document.getElementById(
  //       `code-generating-button-div-${lastgeneratingcode}`
  //     );
  //     if (generatedcode) {
  //       generatedcode.onclick = function () {
  //         showHide(generatedcode?.getAttribute("number"));
  //       };
  //     }
  //   }
  // }, [loading]);

  //Send Question
  const fetchData = () => {
    setResponseStarted(true);
    setIsScrolledUp(false);
    if (inputMessage.trim() === "") return;

    setLoading(true);

    currentInputVar = messageList.length;

    const newInputMessage: Message = {
      type: "input",
      message: (
        <>
          <div className="flex justify-center mb-5">
            <div className="pb-2 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
              <div className="h-full">
                {userData?.data?.profile_picture ? (
                  <img
                    className="rounded-full w-[40px] h-[40px] object-cover"
                    loading="lazy"
                    src={`data:image/jpg;base64,${userData?.data?.profile_picture}`}
                    alt={userData?.data.user_name}
                    style={{ width: 35, height: 35 }}
                  />
                ) : (
                  <img
                    src={ChatUser}
                    style={{ width: 35, height: 35 }}
                    alt={userData?.data.user_name}
                    loading="lazy"
                  />
                )}
              </div>
              <div className=" flex flex-col gap-2 mt-1 w-full">
                <p className=" text-black">{user_name}:</p>
                {selectedImage && (
                  <div className="rounded-md max-sm:pr-4 ">
                    <img
                      src={selectedImage}
                      alt="img"
                      loading="lazy"
                      className=" rounded-md max-h-[400px] "
                    />
                  </div>
                )}
                <p className=" whitespace-break-spaces">{inputMessage}</p>
              </div>
            </div>
          </div>
        </>
      ),
    };

    setMessageList((prevMessageList) => [...prevMessageList, newInputMessage]);
    setInputMessage("");
    setPreviousQuestion(inputMessage);
    setSelectedImage(null);

    const formData = new FormData();
    formData.append("message", inputMessage.trim());
    formData.append("user_id", clientId || "");
    formData.append("model_name", selectedModel);
    if (groupSelected) {
      formData.append(
        "group_id",
        selectedAgentId ? selectedAgentId.toString() : ""
      );
    } else {
      formData.append(
        "agent_id",
        selectedAgentId ? selectedAgentId.toString() : ""
      );
    }
    formData.append("tag", selectedTag || "");
    formData.append("debug", debugMode);
    formData.append("regenerate", "0");
    formData.append("room_id", selectedRoomId.toString());
    formData.append("pdf_name", pdf_name || "");
    formData.append("search_engine", (search_engine || 1).toString());
    formData.append("instruction_id", customInstructions || "");
    formData.append("prompt", userInstructions || "");
    formData.append("version", activeVersionNumber?.toString() || "");
    formData.append("xsd_paths", JSON.stringify(xsdPathConditions));

    api
      .post(`${process.env.REACT_APP_ANSWERS}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        // Update the last message in messageList with chat_details_id
        setMessageList((prevMessageList) => {
          const updated = [...prevMessageList];
          // Find the last input message (should be the one just added)
          for (let i = updated.length - 1; i >= 0; i--) {
            if (updated[i].type === "input" && !updated[i].chat_details_id) {
              updated[i] = {
                ...updated[i],
                chat_details_id: response.data.chat_details_id,
              };
              break;
            }
          }
          return updated;
        });
        var imageRotate = document.getElementById(`logo-${currentInputVar}`);
        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        setLoading(false);
        var imageRotate = document.getElementById(`logo-${currentInputVar}`);
        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }
        var currentdiv = document.getElementById(
          `text-wrap-${currentInputVar}`
        );
        const res = document.createElement("span");
        res.classList.add("errorbox");
        res.innerHTML = error.response.data.message;
        currentdiv?.appendChild(res);
      });
  };

  //Regenerate
  const handleRegenrate = () => {
    if (previousQuestion === "") return;
    if (loading === true) return;

    setLoading(true);

    currentInputVar = messageList.length;

    const newInputMessage: Message = {
      type: "input",
      message: (
        <>
          <div className="flex justify-center">
            <div className=" pb-7 max-w-3xl lg:ml-10 max-md:ml-6 w-full flex flex-row gap-6 items-center">
              {userData?.data?.profile_picture ? (
                <AsyncImage
                  className="rounded-full w-[40px] h-[40px] object-cover"
                  src={`data:image/jpg;base64,${userData?.data?.profile_picture}`}
                  alt={userData?.data.user_name}
                  loading="lazy"
                  style={{ width: 35, height: 35 }}
                  Transition={Blur}
                />
              ) : (
                <AsyncImage
                  src={ChatUser}
                  style={{ width: 35, height: 35 }}
                  Transition={Blur}
                  alt={userData?.data.user_name}
                  loading="lazy"
                />
              )}
              <div className=" flex flex-col gap-2 mt-1 w-full">
                <p className=" text-black">{user_name}:</p>
                {previousQuestion}
              </div>
            </div>
          </div>
        </>
      ),
    };

    setMessageList((prevMessageList) => [...prevMessageList, newInputMessage]);
    setInputMessage("");

    const formData = new FormData();
    formData.append("message", previousQuestion);
    formData.append("user_id", clientId || "");
    formData.append("model_name", selectedModel);
    if (groupSelected) {
      formData.append(
        "group_id",
        selectedAgentId ? selectedAgentId.toString() : ""
      );
    } else {
      formData.append(
        "agent_id",
        selectedAgentId ? selectedAgentId.toString() : ""
      );
    }
    formData.append("tag", selectedTag || "");
    formData.append("debug", debugMode);
    formData.append("regenerate", "1");
    formData.append("room_id", selectedRoomId.toString());
    formData.append("pdf_name", pdf_name || "");
    formData.append("search_engine", (search_engine || 1).toString());
    formData.append("instruction_id", customInstructions || "");
    formData.append("prompt", userInstructions || "");
    formData.append("xsd_paths", JSON.stringify(xsdPathConditions));

    api
      .post(`${process.env.REACT_APP_ANSWERS}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setLoading(false);
        // Update the last message in messageList with chat_details_id
        setMessageList((prevMessageList) => {
          const updated = [...prevMessageList];
          for (let i = updated.length - 1; i >= 0; i--) {
            if (updated[i].type === "input" && !updated[i].chat_details_id) {
              updated[i] = {
                ...updated[i],
                chat_details_id: response.data.chat_details_id,
              };
              break;
            }
          }
          return updated;
        });
        var imageRotate = document.getElementById(`logo-${currentInputVar}`);
        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }
      })
      .catch((error) => {
        console.error("An error occurred:", error);
        setLoading(false);
        var imageRotate = document.getElementById(`logo-${currentInputVar}`);
        if (imageRotate === null) {
        } else {
          imageRotate.className = "";
        }
        var currentdiv = document.getElementById(
          `text-wrap-${currentInputVar}`
        );
        const res = document.createElement("span");
        res.classList.add("errorbox");
        res.innerHTML = error.response.data;
        // const btn = document.createElement("div");
        // btn.addEventListener("click", () => handleRegenrate());
        // btn.innerHTML = "Regenerate";
        // res.appendChild(btn);
        currentdiv?.appendChild(res);
      });
  };

  //Like Like
  const handleLike = async (index: number) => {
    const message = messageList[index];
    if (!message || !message.chat_details_id) return;
    var likeDiv = document.getElementById(`like-${index}`);
    if (likeDiv === null) return;

    ReactDOM.render(<AiFillLike size={18} />, likeDiv);

    var disLikeDiv = document.getElementById(`disLike-${index}`);
    if (disLikeDiv) {
      ReactDOM.render(<AiOutlineDislike size={18} />, disLikeDiv);
    }

    try {
      await api.post(`${process.env.REACT_APP_FEEDBACK}`, {
        chat_details_id: message.chat_details_id,
        like_status: "1",
      });

      toast.success("Thank you for your feedback!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback");
    }
  };

  const handleDisLike = (index: number) => {
    const message = messageList[index];
    if (!message || !message.chat_details_id) return;
    var likeDiv = document.getElementById(`like-${index}`);
    if (likeDiv === null) return;

    ReactDOM.render(<AiOutlineLike size={18} />, likeDiv);

    var disLikeDiv = document.getElementById(`disLike-${index}`);
    if (disLikeDiv) {
      ReactDOM.render(<AiFillDislike size={18} />, disLikeDiv);
    }

    setCurrentFeedbackId(message.chat_details_id);
    setShowDislikeFeedback(true);
  };

  //Copy To Clipboard
  const copyToClipboard = (index: number) => {
    var div = document.getElementById(`copyToClipboard-${index}`);
    if (div === null) {
    } else {
      ReactDOM.render(<HiMiniClipboardDocumentCheck size={25} />, div);
    }

    let finalClip = "";
    messageList.map((item, i) =>
      index < i
        ? item.type === "response"
          ? (finalClip = finalClip + item.message)
          : (index = 10000000000)
        : null
    );

    finalClip = finalClip.replace(/start_code/g, "").replace(/end_code/g, "");

    const unsecuredCopyToClipboard = (text: string) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };

    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard
        .writeText(finalClip)
        .then(() => {
          toast.success("Copied to clipboard!", {
            position: "top-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: false,
            theme: "dark",
          });
          setTimeout(() => {
            ReactDOM.render(<AiOutlineCopy size={18} />, div);
          }, 2000);
        })
        .catch((error) => {
          console.error("Failed to copy text to clipboard: ", error);
        });
    } else {
      unsecuredCopyToClipboard(finalClip);
      toast.success("Copied to clipboard!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    }
  };

  const copyToClipboardHistory = (index: number) => {
    var div = document.getElementById(`copyToClipboard-history-${index}`);
    if (div === null) {
    } else {
      ReactDOM.render(<HiMiniClipboardDocumentCheck size={25} />, div);
    }
    let finalClip = "";
    finalClip = historyData[index].answer;
    finalClip = finalClip.replace(/start_code/g, "").replace(/end_code/g, "");
    const unsecuredCopyToClipboard = (text: string) => {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        console.error("Unable to copy to clipboard", err);
      }
      document.body.removeChild(textArea);
    };
    if (window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(finalClip).then(() => {
        setTimeout(() => {
          ReactDOM.render(<AiOutlineCopy size={18} />, div);
        }, 2000);
      });
    } else {
      unsecuredCopyToClipboard(finalClip);
    }
    toast.success("Copied to clipboard!", {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      theme: "dark",
    });
  };

  //Scroll To Bottom
  const scrollToBottom = () => {
    if (!isScrolledUp) {
      const div = document.getElementById("div-of-scroll");
      if (div === null) {
      } else {
        div.scrollTo({
          top: div.scrollHeight,
          behavior: "smooth",
        });
      }
    }
  };

  useEffect(() => {
    scrollToBottom();
    const handleScroll = () => {
      const div = chatContainerRef.current;

      setIsScrolledUp(true);
      if (div && div.scrollTop + div.clientHeight > div.scrollHeight - 5) {
        setIsScrolledUp(false);
      }
    };

    const div = chatContainerRef.current;
    if (div) {
      div.addEventListener("scroll", handleScroll);

      return () => {
        div.removeEventListener("scroll", handleScroll);
      };
    }
  }, [messageList, historyData]);

  //Like Like
  const handleLikeHistory = async (index: number) => {
    try {
      await api.post(`${process.env.REACT_APP_FEEDBACK}`, {
        chat_details_id: historyData[index].chat_details_id,
        like_status: "1",
      });

      // Update the local state to reflect the like
      setHistoryData((prev) =>
        prev.map((item, i) =>
          i === index
            ? { ...item, like: "1", dislike: "" } // set like, clear dislike
            : item
        )
      );

      toast.success("Your feedback has been noted!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        theme: "dark",
      });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to submit feedback");
    }
  };
  const handleDisLikeHistory = (index: number) => {
    // Update the local state to reflect the dislike
    setHistoryData((prev) =>
      prev.map((item, i) =>
        i === index
          ? { ...item, dislike: "1", like: "" } // set dislike, clear like
          : item
      )
    );

    setCurrentFeedbackId(historyData[index].chat_details_id);
    setShowDislikeFeedback(true);
  };

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_HISTORY}${selectedRoomId}`;

    api
      .get(apiUrl)
      .then((response) => {
        const data = response.data;
        setHistoryData(data);
        setInputMessage("");
        currentInputVar = response.data.length - 1;
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, [selectedRoomId]);

  useEffect(() => {
    // When historyData changes (i.e., after selecting a room), initialize versions from historyData
    if (historyData && historyData.length > 0) {
      const historicVersions = historyData
        .filter((item) => item.chat_settings)
        .map((item) => {
          const versionNum = parseInt(
            item.chat_settings.version_name.replace("V", "")
          );
          return {
            id: item.chat_settings.version_name,
            version: versionNum,
            label: item.chat_settings.version_name, // <-- add this line
            sqlCode: item.chat_settings.sql_query,
            graphCode: item.chat_settings.graph_code,
            previewContent: item.chat_settings.sql_query_result,
            isLive: false,
          };
        });
      setVersions(historicVersions);
    } else {
      setVersions([]); // If no history, clear versions
    }
  }, [historyData]);

  const copyButtonHistory = (codeInputVar: number, inputVar: number) => {
    let codeContent = document.getElementById(`code-content-${codeInputVar}`);
    if (!codeContent) {
      codeContent = document.getElementById(
        `generate-code-content-${codeInputVar}`
      );
    }

    if (codeContent && codeContent.textContent) {
      const textToCopy = codeContent.textContent
        .split("\n")
        .slice(1)
        .join("\n")
        .trim();
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          const copyButton =
            document.querySelector(
              `#parent-code-div-${codeInputVar} .copy-button`
            ) ||
            document.querySelector(
              `#parent-generate-code-div-${codeInputVar} .copy-button`
            );

          if (copyButton instanceof HTMLButtonElement) {
            const originalText = copyButton.textContent;
            copyButton.textContent = "Copied!";
            setTimeout(() => {
              copyButton.textContent = originalText;
            }, 2000);
          }
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
          alert("Failed to copy code to clipboard");
        });
    }
  };

  const handleButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setMoreOptions(false);
  };

  const toggleMoreOptionsButton = () => {
    setMoreOptions((prevMoreOptions) => !prevMoreOptions);
  };

  const handleStopGeneration = async () => {
    try {
      api.post(`${process.env.REACT_APP_STOP_GENERATION}${selectedRoomId}`, {
        search_engine: search_engine,
        model_name: selectedModel,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      var imageRotate = document.getElementById(`logo-${currentInputVar}`);

      if (imageRotate === null) {
      } else {
        imageRotate.className = "";
      }
    } catch (error) {}

    printcode = false;
  };

  const setPdfName = (val: string) => {
    pdf_name = val;
  };
  const setSearchEngine = (val: string) => {
    search_engine = val;
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        setSelectedImage(base64String);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    const shuffledArray = [...examples].sort(() => Math.random() - 0.5);
    const subset = shuffledArray.slice(0, 6);
    setShuffledExamples(subset);
  }, []);

  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     setMessageIndex((prevIndex) => (prevIndex + 1) % Thinking.length);
  //   }, 3000);

  //   return () => clearTimeout(timeoutId);
  // }, [messageIndex]);

  useEffect(() => {
    // Only set up the interval if we're actually showing the thinking message
    if (responseStarted && currentInputVar === messageList.length - 1) {
      const intervalId = setInterval(() => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % Thinking.length);
      }, 3000);

      // Clean up the interval when component unmounts or dependencies change
      return () => clearInterval(intervalId);
    }
  }, [responseStarted, currentInputVar, messageList.length, messageIndex]);

  const [groupSelected, setGroupSelected] = useState(false);

  // const handleGroupSelectedChangeTrue = () => {
  //   setGroupSelected(true);
  // };

  // const handleGroupSelectedChangeFalse = () => {
  //   setGroupSelected(false);
  // };

  const openDeleteAllButton = () => {
    setOpenDeleteAll(true);
  };

  const closeDeleteAllButton = () => {
    setOpenDeleteAll(false);
  };

  const handleDeleteButtonClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      closeDeleteAllButton();
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    setFile(selectedFile || null);
  };

  const getFileLogo = (fileType: any) => {
    switch (fileType) {
      case "xls":
      case "xlsx":
      case "application/vnd.ms-excel":
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        return <PiMicrosoftExcelLogoLight size={25} />;
      case "csv":
      case "text/csv":
        return <BsFiletypeCsv size={25} />;
      default:
        return <CiFileOn size={25} />;
    }
  };

  const openNewChatWithSource = (sourceName: string) => {
    setPdfName(sourceName);

    setMessageList([]);
    setInputMessage("");
    setSelectedAgent(null);
    setSelectedTag("");
    setCustomInstructions(null);
    setCustomInstructionsName("");
    setFile(null);
    setHistoryData([]);
    setSelectedRoomId(Math.round(Math.random() * 1e9));
  };

  // const handleVersionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
  //   setSelectedVersion(e.target.value);
  //   setShowCodeModal(false); // Optionally hide code when switching version
  // };

  // Add click outside handler
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest(".download-dropdown")) {
        setShowDownloadMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [versionId, setVerionId] = useState();

  const versionToSend =
    historyData.length > 0 &&
    typeof versionId === "string" &&
    //@ts-ignore
    !Number.isNaN(Number(versionId?.slice(1)))
      ? //@ts-ignore
        Number(versionId?.slice(1))
      : activeVersionNumber ?? versionCounter.current ?? 0;

  const liveMode = versions.length === 0 || activeVersionId === null;
  const selected = versions.find((v) => v.id === activeVersionId);

  const [previewWidth, setPreviewWidth] = useState(600);

  return (
    <section className="flex flex-row bg-white w-screen h-screen text-zinc-500">
      {/* Sidebar */}
      <aside
        className={` relative ${
          sidebarVisible ? "lg:w-[18%] w-screen p-4" : "w-[0]"
        } h-screen bg-[#000024] transition-all border-r-[1px] `}
      >
        {/* New Chat Button */}
        <NewChatButton
          setHistoryData={setHistoryData}
          setMessageList={setMessageList}
          mindAgentData={mindAgentData}
          setSelectedAgent={setSelectedAgent}
          setSelectedModel={setSelectedModel}
          setSelectedAgentId={setSelectedAgentId}
          setSelectedTag={setSelectedTag}
          setSelectedTagName={setSelectedTagName}
          setPdfName={setPdfName}
          setInputMessage={setInputMessage}
          setGroupSelected={setGroupSelected}
          setSearchEngine={setSearchEngine}
          setSelectedRoomId={setSelectedRoomId}
          setCustomInstructions={setCustomInstructions}
          setUserInstructions={setUserInstructions}
          setCustomInstructionsName={setCustomInstructionsName}
          setUserInstructionsName={setUserInstructionsName}
          setFile={setFile}
          setShowPreview={setShowPreview}
          setShowCodeModal={setShowCodeModal}
          setPreviewContent={setPreviewContent}
          setSqlCode={setSqlCode}
          setGraphCode={setGraphCode}
          setVersions={setVersions}
          versionCounter={versionCounter}
          setActiveVersionNumber={setActiveVersionNumber}
          sidebarVisible={sidebarVisible}
          toggleSidebar={toggleSidebar}
          setSelectedXsdPath={setSelectedXsdPath}
          setXsdPathConditions={setXsdPathConditions}
          setSelectedXsdId={setSelectedXsdId}
          setXsdXml={setXsdXml}
          setTreeData={setTreeData}
          inputRef={inputRef}
        />
        <div
          onClick={handleButtonClick}
          className="h-screen mt-5 overflow-y-scroll custom-scrollbar-chat"
          style={{ maxHeight: "calc(100vh - 180px)" }}
        >
          {/* Chat history */}
          <ChatHistory
            setSelectedModel={setSelectedModel}
            setSelectedAgent={setSelectedAgent}
            setSelectedRoomId={setSelectedRoomId}
            selectedRoomId={selectedRoomId}
            setMessageList={setMessageList}
            setHistoryMainData={setHistoryData}
            messageList={messageList}
            setPdfName={setPdfName}
            setSearchEngine={setSearchEngine}
            loading={loading}
            toggleSidebar={toggleSidebar}
            setSelectedAgentId={setSelectedAgentId}
            setSelectedTag={setSelectedTag}
            setSelectedTagName={setSelectedTagName}
            refreshRooms={refreshRooms}
            setGroupSelected={setGroupSelected}
            setFile={setFile}
            AgentName={mindAgentData && mindAgentData[0].agent}
            AgentID={mindAgentData && mindAgentData[0].id}
            setShowPreview={setShowPreview}
            setShowCodeModal={setShowCodeModal}
            setPreviewContent={setPreviewContent}
            setSqlCode={setSqlCode}
            setGraphCode={setGraphCode}
            setVersions={setVersions}
            setActiveVersionNumber={setActiveVersionNumber}
            versionCounter={versionCounter.current}
            setSelectedXsdPath={setSelectedXsdPath}
            setXsdPathConditions={setXsdPathConditions}
            setSelectedXsdId={setSelectedXsdId}
            setXsdXml={setXsdXml}
            setTreeData={setTreeData}
          />
        </div>

        <div
          className={`pt-6 border-t mt-5 border-[#C5D4EB] flex flex-row items-center justify-between ${
            sidebarVisible ? "" : "hidden"
          }`}
        >
          <div>
            <a href="https://boxmind.ai/" target="_blank" rel="noreferrer">
              <img
                src={Okation}
                width={120}
                height={40}
                alt="OkationAi"
                loading="lazy"
              />
            </a>
          </div>
          <div>
            <button
              onClick={toggleMoreOptionsButton}
              className=" hover:bg-[#45328b] text-white duration-300 p-3 rounded-lg mr-1"
            >
              <BsThreeDots />
            </button>
          </div>
        </div>
        {/* Start More Options */}
        {moreOptions && (
          <div className="z-50 absolute bottom-[110px] w-full pr-8 ">
            <div className="bg-[#061118] rounded-lg shadow-2xl ">
              <div className=" flex flex-col ">
                <p className="p-4 flex justify-center font-bold">
                  More Options
                </p>
                <div className=" border-b" />
                <div className="p-4 flex flex-col gap-3">
                  <button
                    onClick={openDeleteAllButton}
                    className=" bg-red-800 rounded-md text-white p-2 hover:bg-red-900 duration-300 w-full"
                  >
                    Delete All Rooms
                  </button>

                  {/* <button
                    disabled={messageList.length > 0 || historyData.length > 0}
                    onClick={showModel}
                    className={` bg-[#EDEAF8] rounded-md p-2 w-full ${
                      messageList.length > 0 || historyData.length > 0
                        ? ""
                        : "hover:bg-[#b5b1c4] duration-300"
                    }`}
                  >
                    AI Model
                  </button> */}

                  {/* <button
                    disabled={messageList.length > 0 || historyData.length > 0}
                    onClick={showAgent}
                    className={` bg-[#EDEAF8] rounded-md p-2 w-full ${
                      messageList.length > 0 || historyData.length > 0
                        ? ""
                        : "hover:bg-[#b5b1c4] duration-300"
                    }`}
                  >
                    Data Agent
                  </button> */}

                  {/* {!groupSelected && (
                    <button
                      onClick={showTag}
                      className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                    >
                      Sub Data Agent
                    </button>
                  )} */}

                  {/* <button
                    onClick={showCustomInstructions}
                    className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                  >
                    Prompt Instruction
                  </button> */}
                  {/* <button
                    onClick={showUserInstructions}
                    className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                  >
                    Business Rules
                  </button> */}
                  <button
                    onClick={showQuestionsList}
                    className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                  >
                    Prompt Library
                  </button>
                  <button
                    onClick={showXSDExplorer}
                    className="bg-[#EDEAF8] rounded-md p-2 w-full hover:bg-[#b5b1c4] duration-300"
                  >
                    MX Explorer
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* End More Options */}
      </aside>

      {/* Main Chat */}
      <div
        className={`${sidebarVisible ? "w-[87%] max-lg:hidden" : "w-[100%]"} ${
          showPreview ? "w-[50%]" : ""
        } transition-all duration-300`}
      >
        {/* Response Section */}
        {historyData?.length > 0 ? (
          <>
            <div
              className={`flex justify-center gap-5 items-center lg:justify-start px-4 py-2 ${
                sidebarVisible ? "" : " lg:ml-[100px]"
              } `}
            >
              <Link to={"/"}>
                <img
                  src={Turbo}
                  width={130}
                  alt="boxMind"
                  loading="lazy"
                  title="Go back to Home Page"
                />
              </Link>
              {historyData[0]?.pdf_name && (
                <p className="mb-1">{historyData[0]?.pdf_name}</p>
              )}
            </div>
            <div className="flex justify-center h-[85%]">
              <div
                ref={chatContainerRef}
                className="w-full h-[90%] overflow-y-scroll custom-scrollbar pt-8"
                id="div-of-scroll"
              >
                {historyData?.map((data, index) => (
                  <div key={index}>
                    <div className="flex justify-center mb-5">
                      <div className="pb-2 max-w-3xl lg:ml-10 max-sm:ml-6 w-full flex flex-row lg:gap-6 max-sm:gap-4 items-center">
                        <div className="h-full">
                          {userData?.data?.profile_picture ? (
                            <AsyncImage
                              className="rounded-full w-[40px] h-[40px] object-cover"
                              loading="lazy"
                              src={`data:image/jpg;base64,${userData?.data?.profile_picture}`}
                              alt={userData?.data.user_name}
                              style={{ width: 35, height: 35 }}
                              Transition={Blur}
                            />
                          ) : (
                            <AsyncImage
                              src={ChatUser}
                              loading="lazy"
                              style={{ width: 35, height: 35 }}
                              Transition={Blur}
                              alt={userData?.data.user_name}
                            />
                          )}
                        </div>
                        <div className=" flex flex-col gap-2 mt-1 w-full">
                          <p className=" text-black">{user_name}:</p>
                          {data?.image && (
                            <div
                              onClick={() => handleImageClick(data?.image)}
                              className="rounded-md max-sm:pr-4"
                            >
                              <img
                                src={data?.image}
                                alt="img"
                                loading="lazy"
                                className="rounded-md max-h-[400px] "
                              />
                            </div>
                          )}
                          <p className=" whitespace-break-spaces">
                            {data?.question}
                          </p>
                        </div>
                      </div>
                      {expandedImage && data?.image && (
                        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30 flex justify-center items-center z-40">
                          <div>
                            <img
                              src={expandedImage}
                              alt="Expanded img"
                              className="max-w-full max-h-full"
                            />
                          </div>
                          <div className=" fixed top-4 right-4 z-50">
                            <button onClick={() => handleCloseModal()}>
                              <AiOutlineClose
                                size={35}
                                className=" text-white"
                              />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-center mb-5">
                      <div
                        className={`pb-7 max-w-3xl lg:ml-10 max-sm:ml-6 w-full flex flex-row lg:gap-6 max-sm:gap-4 items-center`}
                      >
                        <div className="h-full">
                          <img
                            src={Logo}
                            alt="TurboMind"
                            loading="lazy"
                            width={35}
                            height={35}
                            className=""
                          />
                        </div>
                        <div className="flex flex-col gap-2 mt-1 w-full">
                          <p className="text-black">boxMind:</p>
                          <div>
                            {data.answer
                              ?.split("start_code")
                              .map((part, partIndex) => {
                                if (partIndex === 0) {
                                  return (
                                    <React.Fragment key={partIndex}>
                                      <div
                                        className={`${styles.chatMarkdown} markdown-paragraph`}
                                      >
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkMath,
                                            remarkGfm,
                                          ]}
                                          rehypePlugins={[rehypeMathJax]}
                                        >
                                          {part}
                                        </ReactMarkdown>
                                      </div>
                                    </React.Fragment>
                                  );
                                } else {
                                  const [content, rest] =
                                    part?.split("end_code");
                                  const language = content
                                    .split("\n")[0]
                                    .trim();

                                  return (
                                    <React.Fragment key={partIndex}>
                                      <div
                                        key={partIndex}
                                        className={`parentcodeboxstylehistory whitespace-break-spaces`}
                                      >
                                        <div key={0} className="titlestyle">
                                          <span>{language}</span>{" "}
                                          <button
                                            className="copy-button"
                                            id={`copy-button-${partIndex}-${index}`}
                                            onClick={() => {
                                              const codeContent =
                                                document.getElementById(
                                                  `code-div-history-${partIndex}-${index}`
                                                )?.textContent;
                                              if (codeContent) {
                                                navigator.clipboard
                                                  .writeText(codeContent.trim())
                                                  .then(() => {
                                                    const button =
                                                      document.getElementById(
                                                        `copy-button-${partIndex}-${index}`
                                                      );
                                                    if (button) {
                                                      const originalText =
                                                        button.textContent;
                                                      button.textContent =
                                                        "Copied!";
                                                      setTimeout(() => {
                                                        button.textContent =
                                                          originalText;
                                                      }, 2000);
                                                    }
                                                  })
                                                  .catch((err) => {
                                                    console.error(
                                                      "Failed to copy text: ",
                                                      err
                                                    );
                                                    alert(
                                                      "Failed to copy code to clipboard"
                                                    );
                                                  });
                                              }
                                            }}
                                          >
                                            Copy
                                          </button>
                                        </div>
                                        <div className="overflow-x-scroll w-full">
                                          <SyntaxHighlighter
                                            language={language}
                                            style={dracula}
                                            className="codeboxstyle whitespace-break-spaces"
                                            id={`code-div-history-${partIndex}-${index}`}
                                          >
                                            {content
                                              ?.split("\n")
                                              .map((cont, ind) => {
                                                if (ind === 0) {
                                                  return "";
                                                } else if (ind === 1) {
                                                  return cont;
                                                } else {
                                                  return "\n" + cont;
                                                }
                                              })
                                              .join("")}
                                          </SyntaxHighlighter>
                                        </div>
                                      </div>
                                      <div
                                        className={`${styles.chatMarkdown} markdown-paragraph`}
                                      >
                                        <ReactMarkdown
                                          remarkPlugins={[
                                            remarkMath,
                                            remarkGfm,
                                          ]}
                                          rehypePlugins={[rehypeMathJax]}
                                        >
                                          {rest}
                                        </ReactMarkdown>
                                      </div>
                                    </React.Fragment>
                                  );
                                }
                              })}
                          </div>
                          <div>
                            {data?.chat_settings && (
                              <button
                                onClick={() => {
                                  setShowPreview(true);
                                  setSidebarVisible(false);
                                  const picked = versions.find(
                                    (v) =>
                                      v.label ===
                                      data?.chat_settings?.version_name
                                  );
                                  if (picked) {
                                    setActive(picked.id);
                                    setActiveVersionNumber(picked.version);
                                    setSelectedVersionName(picked.label);
                                  }
                                }}
                                className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 my-2"
                              >
                                {data?.chat_settings?.version_name}
                              </button>
                            )}
                          </div>
                          {/* {data.sources?.split(";")[0] === "" ? null : (
                            <>
                              <br />
                              <div className="max-lg:max-w-[220px] overflow-x-scroll">
                                {data?.sources
                                  ?.split(";")
                                  ?.map((source, index) =>
                                    source.startsWith("Subject: ") ? (
                                      <div
                                        onClick={() => {
                                          setEmailData(source);
                                          openEmailInfoData();
                                        }}
                                        className="cursor-pointer underline mb-1 "
                                      >
                                        {source
                                          .replace("Subject: ", "")
                                          .replace("hrsrc'}", "")
                                          .replace(`hrsrc"}`, "")
                                          .slice(
                                            0,
                                            source
                                              .replace("Subject: ", "")
                                              .replace("hrsrc'}", "")
                                              .replace(`hrsrc"}`, "")
                                              .indexOf(", Sender:")
                                          )}
                                      </div>
                                    ) : (
                                      <div key={index}>
                                        <a
                                          target="_blank"
                                          className="underline duration-300 hover:text-[gray]"
                                          href={`https://bank.boxmindlabs.ai/${encodeURIComponent(
                                            source.endsWith("}")
                                              ? source
                                                  .replace(
                                                    "/home/bizon/uploaded_files/",
                                                    ""
                                                  )
                                                  .slice(0, -10)
                                              : source.replace(
                                                  "/home/bizon/uploaded_files/",
                                                  ""
                                                )
                                          )}`}
                                          rel="noreferrer"
                                        >
                                          {source.replace(
                                            "/home/bizon/uploaded_files/",
                                            ""
                                          )}
                                        </a>
                                        <button
                                          onClick={() =>
                                            openNewChatWithSource(
                                              source.replace(
                                                "/home/bizon/uploaded_files/",
                                                ""
                                              )
                                            )
                                          }
                                          className="ml-2 text-blue-500 underline"
                                        >
                                          Chat
                                        </button>
                                        <br />
                                      </div>
                                    )
                                  )}
                              </div>
                            </>
                          )} */}
                          {/* {data?.debug === 1 && (
                            <div className=" flex flex-col">
                              <br />
                              <div className=" flex flex-row gap-1">
                                <p>Faithfulness: </p>
                                <span>{data?.faithfulness}</span>
                              </div>
                              <div className=" flex flex-row gap-1">
                                <p>Answer Relevancy: </p>
                                <span>{data?.answer_relevancy}</span>
                              </div>
                              <div className=" flex flex-row gap-1">
                                <p>Context Relevancy: </p>
                                <span>{data?.context_relevancy}</span>
                              </div>
                            </div>
                          )} */}
                          {loading && currentInputVar === index ? null : (
                            <div className={`h-full mt-2 max-sm:pr-4`}>
                              <button
                                type="button"
                                onClick={() => copyToClipboardHistory(index)}
                                className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                id={`copyToClipboard-history-${index}`}
                              >
                                <AiOutlineCopy size={18} />
                              </button>
                              <button
                                type="button"
                                onClick={() => handleLikeHistory(index)}
                                className={`ml-2 mb-3 rounded-md text-sm duration-300`}
                                id={`like-history-${index}`}
                                disabled={!!data?.dislike || !!data?.like}
                              >
                                {data?.like ? (
                                  <AiFillLike size={18} />
                                ) : (
                                  <AiOutlineLike size={18} />
                                )}
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDisLikeHistory(index)}
                                className={`ml-2 rounded-md text-sm duration-300`}
                                id={`disLike-history-${index}`}
                                disabled={!!data?.dislike || !!data?.like}
                              >
                                {data?.dislike ? (
                                  <AiFillDislike size={18} />
                                ) : (
                                  <AiOutlineDislike size={18} />
                                )}
                              </button>
                              {/* {index === currentInputVar && (
                                <button
                                  type="button"
                                  onClick={() => handleRegenrate()}
                                  className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`regenerate-${index}`}
                                >
                                  <HiOutlineRefresh size={18} />
                                </button>
                              )} */}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <>
                  {messageList?.map((item, i) =>
                    item.type === "input" ? (
                      <div key={i}>
                        {item?.message}
                        <div className="flex justify-center mb-5">
                          <div className="pb-2 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
                            <div className="h-full">
                              <img
                                src={Logo}
                                alt="TurboMind"
                                width={35}
                                loading="lazy"
                                height={35}
                                className=" animate-spin"
                                id={`logo-${i}`}
                              />
                            </div>
                            <div className="  flex flex-col gap-2 mt-1 w-full">
                              <p className=" text-black">boxMind:</p>
                              {responseStarted ? (
                                currentInputVar === i ? (
                                  selectedAgent === "Google" ||
                                  selectedAgent === "Bing" ||
                                  selectedAgent === "Web_Search" ? (
                                    <div className=" animate-pulse">
                                      {Thinking[messageIndex]}
                                    </div>
                                  ) : null
                                ) : null
                              ) : null}
                              <p id={`text-wrap-${i}`}></p>
                              {loading && currentInputVar === i ? null : (
                                <div className={`h-full mt-2 max-sm:pr-4`}>
                                  <button
                                    type="button"
                                    onClick={() => copyToClipboard(i)}
                                    className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`copyToClipboard-${i}`}
                                  >
                                    <AiOutlineCopy size={18} />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleLike(i)}
                                    className="ml-2 mb-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`like-${i}`}
                                  >
                                    <AiOutlineLike size={18} />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDisLike(i)}
                                    className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`disLike-${i}`}
                                  >
                                    <AiOutlineDislike size={18} />
                                  </button>
                                  {i === currentInputVar && (
                                    <button
                                      type="button"
                                      onClick={() => handleRegenrate()}
                                      className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                      id={`regenerate-${i}`}
                                    >
                                      <HiOutlineRefresh size={18} />
                                    </button>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}
                </>
              </div>
            </div>
          </>
        ) : messageList?.length > 0 ? (
          <>
            <div
              className={`flex justify-center gap-5 items-center lg:justify-start px-4 py-2 ${
                sidebarVisible ? "" : " lg:ml-[100px]"
              } `}
            >
              <Link to={"/"}>
                <img
                  src={Turbo}
                  width={130}
                  alt="boxMind"
                  loading="lazy"
                  title="Go back to Home Page"
                />
              </Link>
              {pdf_name && <p className="mb-1">{pdf_name}</p>}
            </div>
            <div className=" flex justify-center h-[85%]">
              <div
                ref={chatContainerRef}
                className="w-full h-[90%] overflow-y-scroll custom-scrollbar pt-8"
                id="div-of-scroll"
              >
                {messageList?.map((item, i) =>
                  item.type === "input" ? (
                    <div key={i}>
                      {item.message}
                      <div className="flex justify-center mb-5">
                        <div className="pb-7 max-w-3xl md:ml-10 max-sm:ml-6 w-full flex flex-row md:gap-6 max-sm:gap-4 items-center">
                          <div className="h-full">
                            <img
                              src={Logo}
                              loading="lazy"
                              alt="TurboMind"
                              width={35}
                              height={35}
                              className=" animate-spin"
                              id={`logo-${i}`}
                            />
                          </div>
                          <div className="  flex flex-col gap-2 mt-1 w-full">
                            <p className=" text-black">boxMind:</p>
                            {responseStarted ? (
                              currentInputVar === i ? (
                                selectedAgent === "Google" ||
                                selectedAgent === "Bing" ||
                                selectedAgent === "Web_Search" ? (
                                  <div className=" animate-pulse">
                                    {Thinking[messageIndex]}
                                  </div>
                                ) : null
                              ) : null
                            ) : null}
                            <p id={`text-wrap-${i}`}></p>
                            {loading && currentInputVar === i ? null : (
                              <div className={`h-full mt-2 max-sm:pr-4`}>
                                <button
                                  type="button"
                                  onClick={() => copyToClipboard(i)}
                                  className="-mt-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`copyToClipboard-${i}`}
                                >
                                  <AiOutlineCopy size={18} />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleLike(i)}
                                  className="ml-2 mb-3 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`like-${i}`}
                                >
                                  <AiOutlineLike size={18} />
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDisLike(i)}
                                  className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                  id={`disLike-${i}`}
                                >
                                  <AiOutlineDislike size={18} />
                                </button>
                                {/* {i === currentInputVar && (
                                  <button
                                    type="button"
                                    onClick={() => handleRegenrate()}
                                    className="ml-2 rounded-md text-sm hover:text-gray-400 duration-300"
                                    id={`regenerate-${i}`}
                                  >
                                    <HiOutlineRefresh size={18} />
                                  </button>
                                )} */}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </>
        ) : (
          // Response Active
          // Response Inactive
          <div className=" flex justify-center mx-auto content-center lg:pt-10 pt-2">
            <div className="h-[85%] flex flex-col gap-20 justify-center items-center">
              <div className=" flex justify-center items-center">
                <img
                  src={Turbo}
                  width={280}
                  height={50}
                  loading="lazy"
                  alt="TurboMind"
                  className=" max-md:w-[250px]"
                />
              </div>
              <div className="flex flex-col max-lg:px-4">
                {pdf_name ? (
                  <p className=" flex justify-center items-center lg:text-[20px]">
                    {pdf_name}
                  </p>
                ) : (
                  <AnimatePresence>
                    <motion.div
                      initial={{ opacity: 0, y: 4 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -1 }}
                      viewport={{ once: false }}
                      transition={{ duration: 0.3 }}
                      className="grid justify-center grid-cols-2 gap-5"
                    >
                      {shuffledExamples?.map((item, index) => (
                        <div
                          key={index}
                          className="mt-4 p-4 bg-[#EDEAF8] rounded-md cursor-pointer max-w-[1740px] max-md:text-[12px] text-center hover:bg-[#b5b1c4] duration-300"
                          onClick={() => {
                            setInputMessage(item);
                            inputRef.current?.focus();
                          }}
                        >
                          {item}
                        </div>
                      ))}
                    </motion.div>
                  </AnimatePresence>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Input Section */}

        <ChatInput
          selectedImage={selectedImage}
          file={file}
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
          loading={loading}
          fetchData={fetchData}
          handleImageChange={handleImageChange}
          handleRemoveImage={handleRemoveImage}
          handleStopGeneration={handleStopGeneration}
          selectedModel={selectedModel}
          handleFileChange={handleFileChange}
          getFileLogo={getFileLogo}
          width={
            showPreview ? window.innerWidth - previewWidth - 40 : undefined
          }
          inputRef={inputRef}
        />
      </div>

      {/* Preview Panel */}
      <Preview
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        versions={versions}
        activeVersionId={activeVersionId}
        setActive={setActive}
        setActiveVersionNumber={setActiveVersionNumber}
        previewContent={previewContent}
        sqlCode={sqlCode}
        graphCode={graphCode}
        selected={selected}
        liveMode={liveMode}
        showCodeModal={showCodeModal}
        setShowCodeModal={setShowCodeModal}
        setShowDownloadMenu={setShowDownloadMenu}
        showDownloadMenu={showDownloadMenu}
        historyData={historyData}
        selectedVersionName={selectedVersionName}
        selectedRoomId={selectedRoomId}
        activeVersionNumber={activeVersionNumber}
        setVerionId={setVerionId}
        versionToSend={versionToSend}
        onPreviewWidthChange={setPreviewWidth}
        loading={loading}
      />
      {showXSDExplorer && (
        <XSDExplorer
          showXSDExplorer={showXSDExplorer}
          xsdExplorerActive={xsdExplorerActive}
          setSelectedXsdPath={setSelectedXsdPath}
          selectedXsdPath={selectedXsdPath}
          xsdPathConditions={xsdPathConditions}
          setXsdPathConditions={setXsdPathConditions}
          selectedXsdId={selectedXsdId}
          setSelectedXsdId={setSelectedXsdId}
          xsdXml={xsdXml}
          setXsdXml={setXsdXml}
          setTreeData={setTreeData}
          treeData={treeData}
        />
      )}

      {openDeleteAll && (
        <DeleteAllRooms
          handleDeleteButtonClick={handleDeleteButtonClick}
          clientId={clientId}
          setSelectedRoomId={setSelectedRoomId}
          setMessageList={setMessageList}
          setHistoryData={setHistoryData}
          setRefreshRooms={setRefreshRooms}
          setOpenDeleteAll={setOpenDeleteAll}
          setMoreOptions={setMoreOptions}
          setGroupSelected={setGroupSelected}
          setFile={setFile}
          setShowPreview={setShowPreview}
          setShowCodeModal={setShowCodeModal}
          setPreviewContent={setPreviewContent}
          setSqlCode={setSqlCode}
          setVersions={setVersions}
          setActiveVersionNumber={setActiveVersionNumber}
          versionCounter={versionCounter.current}
          setSelectedXsdPath={setSelectedXsdPath}
          setXsdPathConditions={setXsdPathConditions}
          setSelectedXsdId={setSelectedXsdId}
          setXsdXml={setXsdXml}
          setTreeData={setTreeData}
        />
      )}

      {/* Model Component */}
      {/* <Model
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        showModel={showModel}
        modelActive={modelActive}
        onSelectModel={setSelectedModel}
      ></Model> */}

      {/* Agent Component */}
      {/* <Agent
        selectedAgent={selectedAgent}
        showAgent={showAgent}
        setSelectedAgent={setSelectedAgent}
        agentActive={agentActive}
        onSelectAgent={setSelectedAgent}
        setSelectedAgentId={setSelectedAgentId}
        setCanResetTag={setCanResetTag}
        handleGroupSelectedChangeTrue={handleGroupSelectedChangeTrue}
        handleGroupSelectedChangeFalse={handleGroupSelectedChangeFalse}
      ></Agent> */}

      {/* Tag Component */}
      {/* <Tag
        selectedTag1={selectedTag}
        showTag={showTag}
        tagActive={tagActive}
        onSelectTag={setSelectedTag}
        selectedAgentId={selectedAgentId}
        setSelectedTagName={setSelectedTagName}
      ></Tag> */}

      {/* <CustomInstructions
        showCustomInstructions={showCustomInstructions}
        customInstructions={customInstructions}
        setCustomInstructions={setCustomInstructions}
        customInstructionsActive={customInstructionsActive}
        setCustomInstructionsName={setCustomInstructionsName}
      ></CustomInstructions> */}

      {/* <Prompt
        showUserInstructions={showUserInstructions}
        userInstructions={userInstructions}
        setUserInstructions={setUserInstructions}
        userInstructionsActive={userInstructionsActive}
        setUserInstructionsName={setUserInstructionsName}
      /> */}

      <QuestionsList
        showQuestionsList={showQuestionsList}
        setInputMessage={setInputMessage}
        questionsListActive={questionsListActive}
        inputRef={inputRef}
      />

      {isEmailInfoOpen && (
        <EmailInfo
          closePopUp={closePopUp}
          closeSyncData={closeEmailInfoData}
          emailData={emailData}
          selectedAgent={selectedAgentId}
        />
      )}

      {showDislikeFeedback && (
        <DislikeFeedback
          onClose={() => setShowDislikeFeedback(false)}
          chatDetailsId={currentFeedbackId}
          onSubmit={() => {
            setShowDislikeFeedback(false);
            toast.success("Thank you for your feedback!", {
              position: "top-center",
              autoClose: 2000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: false,
              theme: "dark",
            });
          }}
        />
      )}
    </section>
  );
}

export default NewChat;
